import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>{`icon-checkmark-done`}</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#0EB87F" width="24" height="24" rx="12" />
      <path d="M0 0h24v24H0z" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M9.455 15.701l-3.341-3.447L5 13.403 9.455 18 19 8.15 17.886 7z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/icon-checkmark-done.es6.js